// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".54036589acfded04dd45a702167074d3d0d1f233.chunk.js";
};